import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useValidateAxeMutation = (idEntreprise: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      idControleQuinquennal,
      idAxe,
    }: {
      idControleQuinquennal: string;
      idAxe: string;
    }) => ControleQuinquennalApi.validateAxe(idControleQuinquennal, idAxe),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.detail(idEntreprise),
      });
      // Le statut de l'axe alimente la conformité vérificateur de la liste.
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.lists(),
      });
    },
  });
};
